import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { AlertTriangle, CheckCircle2, Info, X, XCircle } from 'lucide-react';
import { useToastStore, type Toast as ToastModel, type ToastTone } from './toast-store';
import styles from './Toast.module.css';

const ICONS: Record<ToastTone, typeof Info> = {
  info: Info,
  success: CheckCircle2,
  danger: XCircle,
  warning: AlertTriangle,
};

function ToastItem({ toast }: { toast: ToastModel }) {
  const dismiss = useToastStore((state) => state.dismiss);
  const Icon = ICONS[toast.tone];

  useEffect(() => {
    if (toast.duration <= 0) return;
    const timer = window.setTimeout(() => {
      dismiss(toast.id);
    }, toast.duration);
    return () => {
      window.clearTimeout(timer);
    };
  }, [toast.id, toast.duration, dismiss]);

  const action = toast.action;

  return (
    <div className={[styles.toast, styles[toast.tone]].join(' ')}>
      <Icon className={styles.icon} size={18} aria-hidden="true" />
      <span className={styles.message}>{toast.message}</span>
      {action ? (
        <button
          type="button"
          className={styles.action}
          onClick={() => {
            action.onClick();
            dismiss(toast.id);
          }}
        >
          {action.label}
        </button>
      ) : null}
      <button
        type="button"
        className={styles.close}
        onClick={() => {
          dismiss(toast.id);
        }}
        aria-label="Kapat"
      >
        <X size={14} aria-hidden="true" />
      </button>
    </div>
  );
}

/**
 * Uygulama kokune BIR KEZ yerlestirilir. Icerik toast-store'dan gelir; herhangi
 * bir yerden `toast({ message })` cagrisi buraya duser.
 */
export function ToastViewport() {
  const toasts = useToastStore((state) => state.toasts);

  if (typeof document === 'undefined') return null;

  return createPortal(
    <div className={styles.viewport} role="status" aria-live="polite">
      {toasts.map((item) => (
        <ToastItem key={item.id} toast={item} />
      ))}
    </div>,
    document.body,
  );
}
